// SIWS CUSTOM: 2027 Calendars picker — calendars-picker.js
// Multi-variant order accumulator. Dealer configures qtys across designs;
// one "Add to Cart" submit-everything button posts a multi-add to /cart/add.js
// then redirects to /cart. orderState is the source of truth (in-memory) —
// no /cart.js round-trip while the dealer is configuring.

'use strict';

(function () {
  // SIWS: hardcoded tier prices keyed by SKU. Cents. Source: Post-July-1
  // flip 2026-07-08; kept in sync with Regios discount records manually.
  // Tier thresholds (250 / 500) are uniform across all calendar variants;
  // tier PRICES differ per design.
  const TIER_PRICES = {
    'CALSRWC27':  { t1: 220, t2: 200, t3: 190 },  // Street Rods
    'CALSTWC27':  { t1: 220, t2: 200, t3: 190 },  // Street Thunder
    'CALSAWC27':  { t1: 220, t2: 200, t3: 190 },  // Scenic America
    'CALWLWC27':  { t1: 220, t2: 200, t3: 190 },  // Wildlife
    'CALMVWC27':  { t1: 220, t2: 200, t3: 190 },  // Motivation
    'CALECWC27':  { t1: 220, t2: 200, t3: 190 },  // Exotic Sports Cars
    'CALAFWC27':  { t1: 220, t2: 200, t3: 190 },  // American Armed Forces
    'CALCAWC27':  { t1: 220, t2: 200, t3: 190 },  // Celebrate America
    'CALGGWC27':  { t1: 220, t2: 200, t3: 190 },  // Glorious Getaways
    'CALPNWC27':  { t1: 220, t2: 200, t3: 190 },  // The Power of Nature
    'CALSDWC27':  { t1: 220, t2: 200, t3: 190 },  // Sporting Dogs
    'CALLAWC27':  { t1: 500, t2: 450, t3: 400 },  // I Love America (PREMIUM)
    'CALMIWC27':  { t1: 500, t2: 450, t3: 400 },  // Michigan (PREMIUM)
    'CALJBPNS27': { t1: 204, t2: 190, t3: 180 },  // Jumbo PNS
    'CALMNPNS27': { t1: 78,  t2: 70,  t3: 65  },  // Mini/Wrench PNS
    'CALSCPNS27': { t1: 142, t2: 128, t3: 116 },  // Scenic PNS
    'CALCCPNS27': { t1: 142, t2: 128, t3: 116 },  // Cruisin' Cars PNS
    'CALSPPNS27': { t1: 142, t2: 128, t3: 116 },  // Sportsman PNS
  };

  // SIWS CUSTOM (2026-05-15): fallbackCents = data-price from the thumb (variant.price in cents).
  // Used when the variant's SKU is not in TIER_PRICES — i.e., the 17 standalone calendar products
  // created 2026-05-15 by duplicating the original multi-variant source. Tier discount math degrades
  // to flat per-unit pricing; updateDiscountStatus still hides its panel cleanly on TIER_PRICES miss.
  function getTierPrice(sku, qty, fallbackCents) {
    const row = TIER_PRICES[sku];
    if (!row) return fallbackCents || 0;
    if (qty >= 500) return row.t3;
    if (qty >= 250) return row.t2;
    return row.t1;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  const root = document.querySelector('[data-siws-calendars]');
  if (!root) return;

  const heroImg          = root.querySelector('[data-cal-hero]');
  const titleEl          = root.querySelector('[data-cal-title]');
  const taglineEl        = root.querySelector('[data-cal-tagline]');
  const descEl           = root.querySelector('[data-cal-description]');
  const minLabelEl       = root.querySelector('[data-cal-min]');
  const stepper          = root.querySelector('[data-qty-stepper]');
  const stepperInpt      = stepper && stepper.querySelector('.siws-qty-stepper__input');
  // SIWS Phase 2-polish (2026-05-13): two [data-cal-atc] buttons may be in the
  // DOM (mobile/desktop pair). Wrap them in a proxy-like object that fans
  // disabled / textContent writes + addEventListener to all matches, so all
  // existing call sites stay unchanged.
  const atcBtnEls = Array.from(root.querySelectorAll('[data-cal-atc]'));
  const atcBtn = {
    get length()      { return atcBtnEls.length; },
    get disabled()    { return atcBtnEls[0] && atcBtnEls[0].disabled; },
    set disabled(v)   { atcBtnEls.forEach(function (b) { b.disabled = v; }); },
    get textContent() { return atcBtnEls[0] && atcBtnEls[0].textContent; },
    set textContent(v){ atcBtnEls.forEach(function (b) { b.textContent = v; }); },
    addEventListener: function (ev, fn) {
      atcBtnEls.forEach(function (b) { b.addEventListener(ev, fn); });
    },
  };
  const errEl            = root.querySelector('[data-cal-error]');
  const discountEl       = root.querySelector('[data-cal-discount-status]');
  const summaryEl        = root.querySelector('[data-cal-order-summary]');
  const currentlyViewing = root.querySelector('[data-cal-currently-viewing]');
  const thumbs           = Array.from(root.querySelectorAll('[data-cal-thumb]'));

  if (!stepper || atcBtn.length === 0 || thumbs.length === 0) return;

  // SIWS: in-memory accumulator. Keys = variant id (string), values = qty (int).
  // A key with qty 0 is removed entirely so Object.entries() reflects the
  // active configuration without filtering.
  const orderState = {};

  // SIWS CUSTOM (2026-05-12): Cached Calendar line items from /cart.js, used by
  // renderCartBlock so refreshOrderSummary can re-prepend the "Already in your
  // cart" block on every stepper change without refetching.
  let cachedCartCalendars = [];

  let activeThumb = thumbs.find(t => t.classList.contains('siws-cal-thumb--active')) || thumbs[0];

  function thumbForVariantId(variantId) {
    return thumbs.find(t => t.dataset.variantId === String(variantId));
  }

  function setQtyForVariant(variantId, value) {
    if (value == null || value === 0) {
      delete orderState[variantId];
    } else {
      orderState[variantId] = value;
    }
  }

  function totalQty() {
    return Object.values(orderState).reduce((sum, q) => sum + q, 0);
  }

  function totalCents() {
    return Object.entries(orderState).reduce((sum, [vid, qty]) => {
      const t = thumbForVariantId(vid);
      const sku = t ? t.dataset.sku : '';
      const fallback = t ? parseInt(t.dataset.price, 10) : 0;
      return sum + qty * getTierPrice(sku, qty, fallback);
    }, 0);
  }

  function activateThumb(thumb) {
    if (!thumb) return;
    activeThumb = thumb;
    thumbs.forEach(t => t.classList.toggle('siws-cal-thumb--active', t === thumb));

    // SIWS: pull everything from data-* — Liquid embedded it on render, no fetch.
    heroImg.src = thumb.dataset.imageSrc;
    heroImg.alt = thumb.dataset.imageAlt || '';
    titleEl.textContent     = thumb.dataset.title;
    taglineEl.textContent   = thumb.dataset.tagline;
    descEl.textContent      = thumb.dataset.description;
    if (minLabelEl) minLabelEl.textContent = thumb.dataset.minQty;

    // SIWS: "Currently viewing" label — DOM-build (no innerHTML) to avoid
    // re-parsing variant titles that may contain ampersands or quotes.
    if (currentlyViewing) {
      const strong = document.createElement('strong');
      strong.textContent = thumb.dataset.title;
      currentlyViewing.replaceChildren(
        document.createTextNode('Currently viewing: '),
        strong
      );
    }

    // Re-target the stepper at this variant + new min, restoring any qty the
    // dealer already configured for it (or empty if untouched).
    stepper.dataset.variantId = thumb.dataset.variantId;
    stepper.dataset.min       = thumb.dataset.minQty;
    const restored = orderState[thumb.dataset.variantId];
    if (stepperInpt) {
      stepperInpt.min   = thumb.dataset.minQty;
      stepperInpt.value = restored != null ? String(restored) : '';
    }

    hideError();
    updateDiscountStatus(restored != null ? restored : null, thumb.dataset.sku);
  }

  function hideError() {
    if (errEl) errEl.hidden = true;
  }

  function showError(text) {
    if (!errEl) return;
    errEl.textContent = text;
    errEl.hidden      = false;
  }

  // SIWS: discount status reflects the ACTIVE variant only — the discount box
  // sits next to that variant's stepper. Tiers (250 / 500) are uniform; prices
  // come from TIER_PRICES per SKU.
  function updateDiscountStatus(qty, sku) {
    if (!discountEl) return;
    const min = parseInt(stepper.dataset.min, 10);
    const row = TIER_PRICES[sku];
    if (qty == null || qty < min || !row) {
      discountEl.hidden      = true;
      discountEl.textContent = '';
      return;
    }
    let text;
    if (qty < 250) {
      const more = 250 - qty;
      text = 'Currently ' + formatMoney(row.t1) + '/unit. ' +
             'Add ' + more + ' more to reach 250+ tier (' +
             formatMoney(row.t2) + '/unit, save ' +
             formatMoney(row.t1 - row.t2) + '/unit).';
    } else if (qty < 500) {
      const more = 500 - qty;
      text = '✓ 250+ tier — ' + formatMoney(row.t2) + '/unit. ' +
             'Add ' + more + ' more for max savings (' +
             formatMoney(row.t3) + '/unit).';
    } else {
      text = '✓ 500+ tier — ' + formatMoney(row.t3) + '/unit. Best price.';
    }
    discountEl.textContent = text;
    discountEl.hidden      = false;
  }

  function refreshOrderSummary() {
    if (!summaryEl) return;
    const entries = Object.entries(orderState);
    if (entries.length === 0) {
      // SIWS CUSTOM (2026-05-15): empty-state copy updated for single-variant products — "Configure designs" was vestigial from the 1-product-17-variants architecture.
      summaryEl.innerHTML =
        '<h4 class="siws-cal-order-summary__title">Adding to Cart</h4>' +
        '<p class="siws-cal-order-summary__empty">Enter quantity above to begin your order.</p>';
    } else {
      const rowsHtml = entries.map(([vid, qty]) => {
        const t     = thumbForVariantId(vid);
        const label = t ? t.dataset.title : 'Calendar';
        const sku   = t ? t.dataset.sku : '';
        const fb    = t ? parseInt(t.dataset.price, 10) : 0;
        const unit  = getTierPrice(sku, qty, fb);
        const sub   = unit * qty;
        return '<tr>' +
          '<td>' + label + '</td>' +
          '<td class="siws-cal-order-summary__qty-cell">' +
            qty + ' &times; ' + formatMoney(unit) + ' = ' + formatMoney(sub) +
          '</td>' +
        '</tr>';
      }).join('');
      summaryEl.innerHTML =
        '<h4 class="siws-cal-order-summary__title">Adding to Cart</h4>' +
        '<table class="siws-cal-order-summary__table">' +
          '<tbody>' + rowsHtml + '</tbody>' +
          '<tfoot>' +
            '<tr class="siws-cal-order-summary__total-row">' +
              '<td>Total</td>' +
              '<td class="siws-cal-order-summary__qty-cell">' + formatMoney(totalCents()) + '</td>' +
            '</tr>' +
          '</tfoot>' +
        '</table>';
    }
    // SIWS CUSTOM (2026-05-12): re-prepend cached cart block (innerHTML above wiped it).
    renderCartBlock(cachedCartCalendars);
  }

  function updateAtcButton() {
    const n = totalQty();
    if (n === 0) {
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Add to Cart';
      return;
    }
    atcBtn.disabled    = false;
    atcBtn.textContent = 'Add ' + n + ' to Cart — ' + formatMoney(totalCents());
  }

  // SIWS: thumbnail click swaps the active variant.
  thumbs.forEach(t => {
    t.addEventListener('click', () => activateThumb(t));
  });

  // SIWS: stepper change → record into orderState, refresh dependent UI.
  stepper.addEventListener('qty-stepper:change', e => {
    const value = e.detail.value;
    const variantId = stepper.dataset.variantId;
    setQtyForVariant(variantId, value);
    updateDiscountStatus(value, activeThumb ? activeThumb.dataset.sku : '');
    refreshOrderSummary();
    updateAtcButton();
    hideError();
  });

  // SIWS: Add to Cart — multi-add submit. One line item per orderState entry.
  // Filters zero/empty; redirects to /cart on success (matches card-holder).
  atcBtn.addEventListener('click', async () => {
    if (atcBtn.disabled) return;

    // SIWS CUSTOM (2026-05-15): per-line_item imprint via window.SIWS.calendarImprint.
    const imprintProps = (window.SIWS && window.SIWS.calendarImprint)
      ? window.SIWS.calendarImprint.getImprintProperties() : {};
    const items = Object.entries(orderState)
      .filter(([, qty]) => qty > 0)
      .map(([vid, qty]) => ({ id: parseInt(vid, 10), quantity: qty, properties: imprintProps }));

    if (items.length === 0) return;

    // SIWS CUSTOM (2026-05-12): Imprint validation gate.
    const imprintPanel = document.querySelector('[data-siws-imprint]');
    if (imprintPanel) {
      const lines = imprintPanel.querySelectorAll('[data-imprint-line]');
      // SIWS CUSTOM (2026-05-15): Line 1 required — exact_repeat checkbox retired.
      const firstLineFilled = lines[0] && lines[0].value.trim().length > 0;
      if (!firstLineFilled) {
        showError('Please fill in Line 1 of the calendar imprint.');
        imprintPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (lines[0]) lines[0].focus();
        return;
      }
    }

    const originalText = atcBtn.textContent;
    atcBtn.disabled    = true;
    atcBtn.textContent = 'Adding…';
    hideError();

    // SIWS: hint the cart.js mixed-cart guard. We use the FIRST variant id as
    // the "intent" since the guard only inspects one — every item in this
    // submit is a Calendar variant, so productType is unambiguous.
    window.__siwsLastAddIntent = { variantId: items[0].id, productType: 'Calendar' };

    try {
      // SIWS CUSTOM (2026-05-12): augment body with Section Rendering API hints
      // so the Dawn cart drawer/notification can re-render itself from the response.
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = {
        items,
        sections:     cart ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'],
        sections_url: window.location.pathname,
      };

      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:    JSON.stringify(body),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Could not add to cart.');
      }

      // SIWS: guard may return synthetic { siws_cancelled: true } when the
      // dealer chose Keep / Cancel in the mixed-cart modal. Don't redirect.
      const payload = await res.clone().json().catch(() => ({}));
      if (payload && payload.siws_cancelled) {
        atcBtn.disabled    = false;
        atcBtn.textContent = originalText;
        return;
      }

      // SIWS CALENDAR IMPRINT PERSISTENCE (Eddy's spec, 2026-05-16): post-ATC
      // clear removed. Imprint values now persist via localStorage in
      // assets/calendar-imprint.js across PDP navigation and reloads. ATC has
      // already frozen the imprint as line item properties on the /cart/add.js
      // payload above (see imprintProps assignment near top of _addToCart) —
      // cart line items are immutable post-ATC regardless of what happens in
      // the input field afterward. resetImprintForm() helper is still exposed
      // on window.SIWS.calendarImprint for any future explicit-clear callers.

      // SIWS CUSTOM (2026-05-12): swap redirect for Dawn cart drawer/notification.
      // Page-mode fallback preserves prior behavior when no cart element exists.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'siws-calendars', cartData: payload });
      }
      if (cart) {
        cart.renderContents(payload);  // also opens the drawer
      } else {
        // SIWS CUSTOM (2026-05-12): Page-mode — stay on PDP, refresh cart bubble.
        const newBubbleHTML = payload.sections && payload.sections['cart-icon-bubble'];
        const liveBubble = document.getElementById('cart-icon-bubble');
        if (newBubbleHTML && liveBubble) {
          const parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
          const inner = parsed.querySelector('.shopify-section');
          if (inner) liveBubble.innerHTML = inner.innerHTML;
        }
        // SIWS CUSTOM (2026-05-12): clear picker state so a re-click can't double-add.
        for (const k in orderState) delete orderState[k];
        if (stepperInpt) stepperInpt.value = '';
        refreshOrderSummary();
        updateAtcButton();
      }
    } catch (err) {
      showError(err.message || 'Something went wrong. Please try again.');
      atcBtn.disabled    = false;
      atcBtn.textContent = originalText;
    }
  });

  // SIWS CUSTOM (2026-05-12): Render the "Already in your cart" block at the
  // top of the order-summary panel from a cached items array. Idempotent —
  // replaces an existing block or prepends a fresh one. Safe to call after
  // refreshOrderSummary's innerHTML wipe.
  function renderCartBlock(items) {
    if (!summaryEl) return;
    const existing = summaryEl.querySelector('.siws-cal-cart-block');
    if (!items || items.length === 0) {
      if (existing) existing.remove();
      return;
    }
    const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const subtotalCents = items.reduce((sum, i) => sum + (i.final_line_price || i.line_price || 0), 0);
    const linesHtml = items.map(i => {
      const label     = i.variant_title || i.title;
      const unitCents = i.final_price || i.price || 0;
      const lineCents = i.final_line_price || i.line_price || 0;
      return '<tr>' +
        '<td>' + label + '</td>' +
        '<td class="siws-cal-order-summary__qty-cell">' +
          i.quantity + ' &times; ' + usd.format(unitCents / 100) + ' = ' + usd.format(lineCents / 100) +
        '</td>' +
      '</tr>';
    }).join('');
    const blockHtml =
      '<div class="siws-cal-cart-block">' +
        // SIWS CUSTOM (2026-05-16): heading capitalization to match "Adding to Cart" (iter 7).
        '<h3 class="siws-cal-cart-block__heading">Already in Your Cart</h3>' +
        '<table class="siws-cal-order-summary__table">' +
          '<tbody>' + linesHtml + '</tbody>' +
          '<tfoot>' +
            '<tr class="siws-cal-order-summary__total-row">' +
              '<td>Subtotal</td>' +
              '<td class="siws-cal-order-summary__qty-cell">' + usd.format(subtotalCents / 100) + '</td>' +
            '</tr>' +
          '</tfoot>' +
        '</table>' +
      '</div>';
    if (existing) {
      existing.outerHTML = blockHtml;
    } else {
      summaryEl.insertAdjacentHTML('afterbegin', blockHtml);
    }
  }

  // SIWS CUSTOM (2026-05-12): Hydrate cachedCartCalendars from /cart.js once at
  // init, then delegate to renderCartBlock. refreshOrderSummary uses the same
  // cache so the block survives every stepper:change without refetching.
  async function hydrateCartCalendars() {
    if (!summaryEl) return;
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      cachedCartCalendars = (cart.items || []).filter(i =>
        (i.product_type || '').toLowerCase().includes('calendar')
      );
    } catch (err) {
      cachedCartCalendars = [];
      return;
    }
    renderCartBlock(cachedCartCalendars);
  }

  // SIWS: initial paint — orderState is empty, so summary shows the empty hint
  // and the button reads "Add to Cart" disabled.
  refreshOrderSummary();
  updateAtcButton();
  hydrateCartCalendars();

  // SIWS CUSTOM (2026-05-12): Keep the "Already in your cart" block fresh after
  // drawer-driven adds (own picker or any other cartUpdate source).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      hydrateCartCalendars();
    });
  }
})();
